import { api } from './api';

export const orchestratorService = {
  /**
   * Enviar mensaje al orquestador central.
   * El orquestador decide automáticamente qué agente(s) ejecutar.
   */
  chat: async (userInput, tenantId = null, context = null) => {
    const response = await api.post('/orchestrator/chat', {
      user_input: userInput,
      tenant_id: tenantId,
      context,
    });
    return response.data;
  },

  /**
   * Ejecutar un workflow predefinido.
   */
  runWorkflow: async (workflowId, userInput = null, tenantId = null, context = null) => {
    const response = await api.post(`/orchestrator/workflow/${workflowId}/run`, {
      user_input: userInput,
      tenant_id: tenantId,
      context,
    });
    return response.data;
  },

  /**
   * Listar workflows disponibles.
   */
  listWorkflows: async () => {
    const response = await api.get('/orchestrator/workflows');
    return response.data;
  },

  /**
   * Obtener historial de orquestación para un tenant.
   */
  getHistory: async (tenantId, limit = 50, offset = 0) => {
    const response = await api.get(`/orchestrator/history/${tenantId}`, {
      params: { limit, offset },
    });
    return response.data;
  },

  /**
   * Health check del orquestador.
   */
  health: async () => {
    const response = await api.get('/orchestrator/health');
    return response.data;
  },
};
